import { localDate } from '@/platform/lib/utils';
import { CakeIcon, IdentificationIcon } from '@heroicons/react/24/outline';

const EmployeeCard = ({ employee, link = false }) => {
    if (!employee) {
        return null;
    }

    const { id, name, bsn, birth_date } = employee;

    return (
        <div className='min-w-0'>
            {link ? (
                <a
                    href={`/employees/${id}`}
                    target='_blank'
                    rel='noreferrer'
                    className='text-primary-500 text-sm font-semibold'
                >
                    {name}
                </a>
            ) : (
                <p className='text-sm font-semibold text-gray-900'>{name}</p>
            )}

            {(bsn || birth_date) && (
                <div className='mt-1 flex items-center gap-3 text-xs text-gray-500'>
                    {bsn && (
                        <span className='flex items-center gap-1'>
                            <IdentificationIcon className='size-4' />
                            {bsn}
                        </span>
                    )}
                    {birth_date && (
                        <span className='flex items-center gap-1'>
                            <CakeIcon className='size-4' />
                            {localDate(birth_date)}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default EmployeeCard;
